import { SnackbarActionTypes } from "./snackbar.types";

export const showSnackbar = ({message,navTo} )=> async dispatch => {
  console.log(message);
  dispatch({ type: SnackbarActionTypes.SHOW_SNACKBAR, payload : {message,navTo} });
  return;
};

export const hideSnackbar = () => ({
  type: SnackbarActionTypes.HIDE_SNACKBAR
});
